import { defaultFill } from '../../utils/constants';
var muiLaptop16 = {
    paths: [
        {
            path: 'M1.00087166,11 C0.448105505,11 0,10.5561352 0,10 L0,9 L1,9 L1,0.995577499 C1,0.445735229 1.44994876,0 2.00684547,0 L13.9931545,0 C14.5492199,0 15,0.444836974 15,0.995577499 L15,9 L16,9 L16,10 C16,10.5522847 15.5553691,11 14.9991283,11 L1.00087166,11 Z M13,2 L3,2 L3,9 L13,9 L13,2 Z',
            fill: defaultFill,
        },
    ],
    title: 'Laptop',
    width: 16,
    height: 11,
};
var muiLaptop24 = {
    paths: [
        {
            path: 'M21.0081969,0 C21.5559546,0 22,0.449948758 22,1.00684547 L22,12 L24,12 L24,14.0010434 C24,14.5527519 23.5525308,15 22.9993054,15 L1.00069463,15 C0.448026248,15 0,14.5573397 0,14.0010434 L0,12 L2,12 L2,1.00684547 C2,0.450780073 2.45530558,0 2.99180311,0 L21.0081969,0 Z M10,12 C10,12.5561352 10.4519098,13 11.0093689,13 L11.0093689,13 L12.9906311,13 C13.5566468,13 14,12.5522847 14,12 L14,12 L20,12 L20,2 L4,2 L4,12 Z',
            fill: defaultFill,
        },
    ],
    title: 'Laptop',
    width: 24,
    height: 15,
};
var muiLaptop = {
    base: muiLaptop16,
    smIcon: muiLaptop16,
    lgIcon: muiLaptop24,
};
export { muiLaptop };
//# sourceMappingURL=laptop.js.map